import { useFormContext } from 'react-hook-form'

import { CheckboxField } from '@/shared/ui/Form'

/**
 * Consentimento de descoberta, desligado por padrão.
 *
 * O texto é conteúdo de conformidade, não microcópia: precisa nomear quem passa a
 * ver o perfil. Sem consentimento a participação fica fora do conjunto de
 * candidatos a recomendação — é o que dá base legal ao compartilhamento.
 *
 * O alvo de toque é o `<label>` inteiro, não a caixa — a de 20px ficaria abaixo
 * do piso do WCAG 2.2 SC 2.5.8 (ACCESSIBILITY.md §3). Esse cuidado era feito
 * aqui na mão e hoje vive no `CheckboxField`, junto com a associação da
 * descrição por `aria-describedby`.
 *
 * Histórico que vale registrar: antes disto o campo usava `FormSwitch`, que
 * promete um interruptor e renderizava um campo de texto — `FormCheck` fixa
 * `type="checkbox"` e o `type="switch"` inválido vencia no spread.
 */
export const NetworkingConsent = () => {
  const { watch } = useFormContext()
  const granted = watch('networking_opt_in')

  return (
    <div className="flex flex-col gap-2">
      <CheckboxField
        name="networking_opt_in"
        label="Quero ser encontrado no networking do evento"
        description="Outros participantes e as empresas patrocinadoras deste evento poderão ver seu nome, foto, apresentação e interesses. Você pode desativar quando quiser — seus interesses continuam salvos."
        className={
          granted
            ? 'border border-brand bg-brand/5 p-4'
            : 'border border-gray-600 p-4 hover:bg-gray-100'
        }
      />

      {!granted && (
        <p className="m-0 px-1 text-sm text-gray-700">
          Com a opção desativada, você continua recebendo sugestões, mas não
          aparece nas sugestões de outras pessoas.
        </p>
      )}
    </div>
  )
}
